import React, { useState } from 'react';
import { Check, X, Sparkles, Shield, Users, User, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TopBar } from '../components/TopBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function PricingPage() {
  const [isAnnual, setIsAnnual] = useState(true);
  return <div className="flex flex-col min-h-screen w-full font-inter bg-white" data-id="element-4594" data-mp="9xm57za4mylp">
      <TopBar data-id="element-4595" data-mp="xlviudx6sg1r" />
      <Header data-id="element-4596" data-mp="xnge65rbs30o" />

      {/* Hero Section */}
      <section className="w-full bg-white py-16 md:py-24 border-b border-gray-200" data-id="element-4597" data-mp="12kq2fi2za8mx">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center" data-id="element-4598" data-mp="nvttzjx0etls">
          <h1 className="text-4xl md:text-6xl font-extrabold text-[#111111] mb-6 leading-tight" data-id="element-4599" data-mp="nthereimyxcf">
            Honest pricing. No games.
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-4600" data-mp="1gj6k242dpjju">
            No upsells. No confusing tiers. No fear-mongering. One price gets
            your whole family guided, protected, and on track.
          </p>

          {/* Monthly/Annual Toggle */}
          <div className="mt-12 flex items-center justify-center space-x-4" data-id="element-4601" data-mp="1e1ns4ymd6ynk">
            <span className={`text-lg font-medium ${!isAnnual ? 'text-[#111111]' : 'text-gray-500'}`} data-id="element-4602" data-mp="1spim0ic3z928">
              Monthly
            </span>
            <button onClick={() => setIsAnnual(!isAnnual)} className="relative w-16 h-8 bg-#[631bb7] rounded-full p-1 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-#[631bb7]" data-id="element-4603" data-mp="1nwz81k9iebww">
              <div className={`w-6 h-6 bg-white rounded-full shadow-md transform transition-transform duration-200 ease-in-out ${isAnnual ? 'translate-x-8' : 'translate-x-0'}`} data-id="element-4604" data-mp="2bowlffslxc04" />
            </button>
            <span className={`text-lg font-medium ${isAnnual ? 'text-[#111111]' : 'text-gray-500'}`} data-id="element-4605" data-mp="hb5c6he6wu57">
              Annual <span className="text-[#631bb7] text-sm" data-id="element-4606" data-mp="11zo5wh2fplyk">(Save 20%)</span>
            </span>
          </div>
        </div>
      </section>

      {/* Pricing Tiers */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24" data-id="element-4607" data-mp="161rrhyiti6xk">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4608" data-mp="1b033aesoarif">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start" data-id="element-4609" data-mp="1b2pbmgne1b1p">
            {/* Foundation (Free) */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm flex flex-col h-full" data-id="element-4610" data-mp="1kysbffuroxlh">
              <div className="mb-6" data-id="element-4611" data-mp="1ozlyy84asadu">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-4612" data-mp="1oykni2jddlvl">
                  Foundation
                </h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-4613" data-mp="1trm2sbnhnnfp">
                  Essential basics for everyone
                </p>
              </div>
              <div className="mb-8" data-id="element-4614" data-mp="23pjrt1d69o9d">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-4615" data-mp="23ql6dftecsvu">
                  $0
                </span>
                <span className="text-gray-500 ml-1" data-id="element-4616" data-mp="28m0gpxs746ni">/forever</span>
              </div>
              <Link to="/onboarding" className="w-full block text-center py-3 px-4 bg-gray-100 text-[#111111] font-bold rounded-lg hover:bg-gray-200 transition-colors mb-8" data-id="element-4617" data-mp="3t7goz5mbkykx">
                Start for Free
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-4618" data-mp="3e9y105hgupej">
                <li className="flex items-start" data-id="element-4619" data-mp="3eb92fynfvl2h">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4620" data-mp="fpxub29gytbk" />
                  <span className="text-gray-700 text-sm" data-id="element-4621" data-mp="arwb8hc1mu03">For 1 person</span>
                </li>
                <li className="flex items-start" data-id="element-4622" data-mp="60o27memlang">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4623" data-mp="5zczlpwx28xx" />
                  <span className="text-gray-700 text-sm" data-id="element-4624" data-mp="11tk6mohfq4e">
                    See where you stand with a free safety checkup
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4625" data-mp="tqs33m0fiwar">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4626" data-mp="toxm2isa3oby" />
                  <span className="text-gray-700 text-sm" data-id="element-4627" data-mp="e7phfnh9gdx5">
                    Access your first critical walkthroughs
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4628" data-mp="4bmi0pdsmtdw">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4629" data-mp="4cxmysiz676l" />
                  <span className="text-gray-700 text-sm" data-id="element-4630" data-mp="9afse8xsa49u">
                    No credit card required — ever
                  </span>
                </li>
              </ul>
            </div>

            {/* Individual */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm flex flex-col h-full relative" data-id="element-4631" data-mp="120fs7tdfgr5u">
              <div className="mb-6" data-id="element-4632" data-mp="s8idwdr4hj2w">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-4633" data-mp="s7h38ae0qylp">
                  Individual
                </h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-4634" data-mp="1fwt6ktmo0cg3">
                  Full access for one person
                </p>
              </div>
              <div className="mb-8" data-id="element-4635" data-mp="35f89qm8a1fcr">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-4636" data-mp="35e6xiefiymtg">
                  {isAnnual ? '$79' : '$7.99'}
                </span>
                <span className="text-gray-500 ml-1" data-id="element-4637" data-mp="30ekibzg4ywi0">
                  {isAnnual ? '/year' : '/mo'}
                </span>
                {isAnnual && <p className="text-green-600 text-sm mt-1 font-medium" data-id="element-4638" data-mp="3a7j7pjjgir2o">
                    Save $16/year
                  </p>}
              </div>
              <Link to="/onboarding" className="w-full block text-center py-3 px-4 bg-[#1a0647] text-white font-bold rounded-lg hover:bg-[#2d0b75] transition-colors mb-8" data-id="element-4639" data-mp="2hi2jyz6s7ycs">
                Choose Individual
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-4640" data-mp="2ri36sv3v0wlq">
                <li className="flex items-start" data-id="element-4641" data-mp="aps0s8mxdgki">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4642" data-mp="6phwr1ip108a" />
                  <span className="text-gray-700 text-sm" data-id="element-4643" data-mp="6rki388wi56o">For 1 person</span>
                </li>
                <li className="flex items-start" data-id="element-4644" data-mp="2zm2mwchpdw0i">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4645" data-mp="34i9su5a3n7ig" />
                  <span className="text-gray-700 text-sm" data-id="element-4646" data-mp="39ifglad909v9">
                    Everything in Foundation
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4647" data-mp="3dj7qm5ty2isl">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4648" data-mp="2gtqizlbeimo9" />
                  <span className="text-gray-700 text-sm font-semibold" data-id="element-4649" data-mp="2lsl2kph70f9f">
                    Full access to all 39 guided walkthroughs
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4650" data-mp="2ps29lnc9pkgp">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4651" data-mp="2ul55410lv3zj" />
                  <span className="text-gray-700 text-sm" data-id="element-4652" data-mp="1y38u5rtowb86">
                    Ongoing check-ins and reminders to keep habits on track
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4653" data-mp="2227yba7lk3yk">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4654" data-mp="1uk08yay3423d" />
                  <span className="text-gray-700 text-sm" data-id="element-4655" data-mp="1plqg46zu1dkx">
                    Personalized action queue — always know what to do next
                  </span>
                </li>
              </ul>
            </div>

            {/* Family (Best Value) */}
            <div className="bg-white rounded-2xl p-8 border-2 border-[#631bb7] shadow-xl flex flex-col h-full relative transform md:-translate-y-4" data-id="element-4656" data-mp="1gneg5ed2t3ft">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#631bb7] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide" data-id="element-4657" data-mp="16v8t8j1olc7h">
                Best Value
              </div>
              <div className="mb-6 mt-2" data-id="element-4658" data-mp="xwn9ikkh3r54">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-4659" data-mp="svg0ki6lglwv">Family</h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-4660" data-mp="sxk4h04htkx5">
                  Complete protection for everyone
                </p>
              </div>
              <div className="mb-8" data-id="element-4661" data-mp="2budrxggs9d9j">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-4662" data-mp="2br7yjp14fp80">
                  {isAnnual ? '$199' : '$19.99'}
                </span>
                <span className="text-gray-500 ml-1" data-id="element-4663" data-mp="22tfkspb1spmq">
                  {isAnnual ? '/year' : '/mo'}
                </span>
                {isAnnual && <p className="text-green-600 text-sm mt-1 font-medium" data-id="element-4664" data-mp="27tk38kvinufl">
                    Save $40/year
                  </p>}
              </div>
              <Link to="/onboarding" className="w-full block text-center py-3 px-4 bg-[#631bb7] text-white font-bold rounded-lg hover:bg-[#521099] transition-colors mb-8 shadow-md" data-id="element-4665" data-mp="1xub99s0nift8">
                Choose Family
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-4666" data-mp="1a3p6og9f1nqm">
                <li className="flex items-start" data-id="element-4667" data-mp="1a6bbi84x9p55">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4668" data-mp="1f20fcnnz5s79" />
                  <span className="text-gray-700 text-sm font-bold" data-id="element-4669" data-mp="vgqfmmeh0vcf">
                    Up to 6 people
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4670" data-mp="qjzz5xyr7xqh">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4671" data-mp="15fz8fbxlo3x7" />
                  <span className="text-gray-700 text-sm" data-id="element-4672" data-mp="10gmjmln64mrz">
                    Everything in Individual
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4673" data-mp="1eejijop3h59t">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4674" data-mp="19haxngckan4v" />
                  <span className="text-gray-700 text-sm font-semibold" data-id="element-4675" data-mp="19f6vb2ub9w6p">
                    One dashboard to coordinate safety across your whole
                    household
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4676" data-mp="1x6c9ldklsgew">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4677" data-mp="1x75d85o9mpst" />
                  <span className="text-gray-700 text-sm" data-id="element-4678" data-mp="1t6bm73fj0uvp">
                    Each person gets their own guided path
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4679" data-mp="129wr1xl9wn3f">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4680" data-mp="12828gpxh572i" />
                  <span className="text-gray-700 text-sm" data-id="element-4681" data-mp="xblfnifby4j3">
                    You can see where everyone stands — and help where needed
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4682" data-mp="1pzhd4pcq40gx">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4683" data-mp="1px4wcfipbw5g" />
                  <span className="text-gray-700 text-sm" data-id="element-4684" data-mp="1l0nwio253tcj">
                    No one falls through the cracks
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Lifetime Offer Section */}
      <section className="w-full bg-[#1a0647] py-16 md:py-24 relative overflow-hidden" data-id="element-4685" data-mp="4m4qquqx55rm">
        {/* Background decorative elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-4686" data-mp="iztb6lp3u9u">
          <div className="absolute top-10 left-10 w-64 h-64 bg-[#8041bf] rounded-full filter blur-3xl" data-id="element-4687" data-mp="2c5ju11oic0nm"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#00f4f8] rounded-full filter blur-3xl" data-id="element-4688" data-mp="2g6vih3vnafu8"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-4689" data-mp="2pzkvw4ara3s7">
          <div className="text-center mb-12" data-id="element-4690" data-mp="2q0vulppcglcg">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-4691" data-mp="2ux2vv56sp8o2">
              For our first 1,000 families: lifetime access at a founder's
              price.
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-4692" data-mp="33ykjr9qg2enb">
              One payment. All future updates included. When we add new
              walkthroughs, new check-ins, and new protections — you get them
              automatically. This pricing goes away at 1,000 members.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-4693" data-mp="1ek4lt4tmka2l">
            {/* Lifetime Individual */}
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl p-8 border border-white border-opacity-20 hover:bg-opacity-15 transition-all" data-id="element-4694" data-mp="2hwmpamya5it1">
              <div className="flex items-center justify-between mb-6" data-id="element-4695" data-mp="2qx1f9zm6vm2v">
                <h3 className="text-2xl font-bold text-white" data-id="element-4696" data-mp="2lw3xho53cu1w">
                  Lifetime Individual
                </h3>
                <User className="text-[#00f4f8] w-8 h-8" data-id="element-4697" data-mp="30sct8fprwp9k" />
              </div>
              <div className="mb-6" data-id="element-4698" data-mp="2vvcn64sxbmig">
                <span className="text-5xl font-extrabold text-white" data-id="element-4699" data-mp="2vub2d8m3vlnj">$199</span>
                <p className="text-[#00f4f8] font-medium mt-2" data-id="element-4700" data-mp="39koabayzz0cv">
                  One-Time Payment
                </p>
              </div>
              <p className="text-gray-300 mb-8" data-id="element-4701" data-mp="35mqkc5xeka8f">
                Includes all future updates to the Individual Plan.
              </p>
              <button className="w-full py-4 px-6 bg-white text-[#1a0647] font-bold rounded-lg hover:bg-gray-100 transition-colors" data-id="element-4702" data-mp="3elu2n7oqwllv">
                Get Lifetime Individual
              </button>
            </div>

            {/* Lifetime Family */}
            <div className="bg-gradient-to-br from-[#631bb7] to-[#521099] rounded-2xl p-8 border border-white border-opacity-20 shadow-2xl transform md:scale-105" data-id="element-4703" data-mp="6ygrjmxmxdne">
              <div className="flex items-center justify-between mb-6" data-id="element-4704" data-mp="3t6q60o60fwyi">
                <h3 className="text-2xl font-bold text-white" data-id="element-4705" data-mp="3fftdexc33frg">
                  Lifetime Family
                </h3>
                <Users className="text-white w-8 h-8" data-id="element-4706" data-mp="3k7bi9wh8a0hp" />
              </div>
              <div className="mb-6" data-id="element-4707" data-mp="35ifam0j32phm">
                <span className="text-5xl font-extrabold text-white" data-id="element-4708" data-mp="35jhxlxdac7s9">$599</span>
                <p className="text-white text-opacity-90 font-medium mt-2" data-id="element-4709" data-mp="3aggtolgieot3">
                  One-Time Payment
                </p>
              </div>
              <p className="text-white text-opacity-80 mb-8" data-id="element-4710" data-mp="2wjlescdku354">
                Includes all future updates to the Family Plan for up to 6
                members.
              </p>
              <button className="w-full py-4 px-6 bg-[#00f4f8] text-[#1a0647] font-bold rounded-lg hover:bg-[#00e0e4] transition-colors shadow-lg" data-id="element-4711" data-mp="2tfcntbfbeft6">
                Get Lifetime Family
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Competitive Comparison */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-4712" data-mp="2eqpw0a8i3vl2">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4713" data-mp="2apo4ygoqmpu6">
          <div className="text-center mb-12" data-id="element-4714" data-mp="2an1otsns720c">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-4" data-id="element-4715" data-mp="25p9vqvbeh9uk">
              Why Overpay for Anxiety When You Can Invest in Capability?
            </h2>
          </div>

          <div className="overflow-x-auto" data-id="element-4716" data-mp="1vsngcm1ufazx">
            <table className="w-full max-w-5xl mx-auto border-collapse" data-id="element-4717" data-mp="1vtyea58lxoj4">
              <thead data-id="element-4718" data-mp="3v3y8ixnwktt4">
                <tr data-id="element-4719" data-mp="3v4gc6fcwaab2">
                  <th className="text-left py-4 px-6 font-bold text-gray-500 uppercase text-sm tracking-wider border-b-2 border-gray-100" data-id="element-4720" data-mp="3v2vieryemve9"></th>
                  <th className="text-left py-4 px-6 border-b-2 border-[#631bb7]" data-id="element-4721" data-mp="2gq275jyslq3">
                    <div className="text-xl font-bold text-[#631bb7]" data-id="element-4722" data-mp="6iuqrpvk2s5v">
                      Caveo
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 border-b-2 border-gray-100" data-id="element-4723" data-mp="bauy43dygnch">
                    <div className="text-xl font-bold text-gray-600" data-id="element-4724" data-mp="g7uwrt8h6ntk">
                      Norton 360 / Aura
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 border-b-2 border-gray-100" data-id="element-4725" data-mp="3jpmqbc29fftv">
                    <div className="text-xl font-bold text-gray-600" data-id="element-4726" data-mp="3oozec04vasy1">
                      Geek Squad
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-4727" data-mp="3tlpuengo9ojg">
                {[{
                label: 'Philosophy',
                caveo: 'Gets the important things done — and keeps them done',
                competitor1: 'Sells reactive alerts & fear',
                competitor2: 'Profits from your tech breaking'
              }, {
                label: 'Cost',
                caveo: 'Starts at $7.99/mo',
                competitor1: '$12 - $35/mo',
                competitor2: '$99+ per incident'
              }, {
                label: 'Experience',
                caveo: 'Step-by-step walkthroughs anyone can follow',
                competitor1: 'Confusing technical jargon',
                competitor2: 'In-person visit required'
              }, {
                label: 'Incentive',
                caveo: 'We win when you feel confident',
                competitor1: 'They win when you stay anxious',
                competitor2: 'They win when you have problems'
              }, {
                label: 'Outcome',
                caveo: "A family that's actually protected — not just subscribed to something",
                competitor1: 'Dependency & Confusion',
                competitor2: 'A temporary fix'
              }].map((row, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-4728" data-mp="1egymnoukibmt" data-mpi={idx}>
                    <td className="py-6 px-6 font-bold text-[#111111]" data-id="element-4729" data-mp="278i9diqdi7tk">
                      {row.label}
                    </td>
                    <td className="py-6 px-6 font-medium text-[#631bb7] bg-[#631bb7] bg-opacity-5" data-id="element-4730" data-mp="2c5s6lkk07nry">
                      {row.caveo}
                    </td>
                    <td className="py-6 px-6 text-gray-600" data-id="element-4731" data-mp="227m5v69xonoo">
                      {row.competitor1}
                    </td>
                    <td className="py-6 px-6 text-gray-600" data-id="element-4732" data-mp="mq288jsuzyxf">
                      {row.competitor2}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-4733" data-mp="1dhfh13q6586d">
        <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-4734" data-mp="19floxju1hcht">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-12 text-center" data-id="element-4735" data-mp="19i7vph93vnyz">
            Your Questions, Answered.
          </h2>
          <div className="space-y-6" data-id="element-4736" data-mp="217jaii9n7rjn">
            {[{
            q: 'Can I cancel my subscription at any time?',
            a: 'Yes. You can cancel your monthly or annual plan at any time from your account settings. No questions asked. Your plan will remain active until the end of the current billing period.'
          }, {
            q: 'What happens when you add new modules or features?',
            a: "All new modules and feature updates are included in the Individual, Family, and Lifetime plans at no extra cost. Our platform is constantly evolving to meet new threats, and you'll always have the latest protection."
          }, {
            q: 'How does the Family Plan work for different family members?',
            a: "The Family Plan gives you a central dashboard to invite up to 5 other family members. You can use our role-based views to see different information; for example, an adult child can see their parent's progress and help them with tasks, while the parent sees a simplified view focused on their own learning."
          }, {
            q: 'Is the Free (Foundation) plan free forever?',
            a: "Yes. The Foundation plan is free forever. It's a great way to get started with our basic security assessment and introductory modules to see how Caveo works."
          }, {
            q: 'What if I’m not satisfied?',
            a: "We offer a 30-day money-back guarantee on all paid plans, including lifetime memberships. If you're not happy for any reason, just let us know within 30 days of your purchase for a full refund."
          }].map((faq, index) => <div key={index} className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm" data-id="element-4737" data-mp="13wasqq0z1wjx" data-mpi={index}>
                <h3 className="text-lg font-bold text-[#111111] mb-2" data-id="element-4738" data-mp="1cw7a06l17t4y">
                  {faq.q}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4739" data-mp="1htpm25ucioh6">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-4740" data-mp="1rjsdw2pqdwdx">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center" data-id="element-4741" data-mp="1rmek9z0vy5uk">
          <h2 className="text-3xl md:text-5xl font-bold text-[#111111] mb-6" data-id="element-4742" data-mp="1vl47ejbq71re">
            Start free. See what your family hasn't done yet. Upgrade whenever
            you're ready.
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-10" data-id="element-4743" data-mp="25kbfos3ls67n">
            No email required. No credit card. Just a clear picture of where you
            stand — in 3 minutes.
          </p>
          <Link to="/onboarding" className="inline-block bg-[#631bb7] text-white px-10 py-4 rounded-lg font-bold text-lg hover:bg-[#521099] transition-all shadow-lg transform hover:-translate-y-1" data-id="element-4744" data-mp="2an2mgbdf7jq0">
            Get Started for Free
          </Link>
        </div>
      </section>

      <Footer data-id="element-4745" data-mp="2ygcc1p3xy58i" />
    </div>;
}